import { render, staticRenderFns } from "./DefaultDetailedIssueBody.vue?vue&type=template&id=7701f95f&scoped=true"
import script from "./DefaultDetailedIssueBody.vue?vue&type=script&lang=js"
export * from "./DefaultDetailedIssueBody.vue?vue&type=script&lang=js"
import style0 from "./DefaultDetailedIssueBody.vue?vue&type=style&index=0&id=7701f95f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7701f95f",
  null
  
)

export default component.exports